import React, {Component} from "react";

import Constants from "../../../constants/constants";

import {startNewFunctionalSkillSession} from "../../../modules/functional_skills.js";
import withStaticImages from "../../../services/utils/imageNameRetriever";

class QuickPlaySkillCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false
        };


        
    }

    async startNewSession() {
        let {functional_skill_id, token, can_start, start_functional_skill} = this.props;
        let {loading} = this.state;


        if (loading || !can_start) {
            return;
        }

        start_functional_skill();

        this.setState({loading: true});
        let startNewFunctionalSkillSessionResponse = await startNewFunctionalSkillSession(functional_skill_id, token);

        let platformURL = "https://" + window.location.hostname;

        if (startNewFunctionalSkillSessionResponse && startNewFunctionalSkillSessionResponse.data && startNewFunctionalSkillSessionResponse.data.success) {
            let functionalSkillSessionID = startNewFunctionalSkillSessionResponse.data.new_functional_skill_session_id;
            window.location = Constants.getPlayContentUrl() + `/play_game?functional_skill_session_id=${functionalSkillSessionID}&auth=${token}&purl=${platformURL}`;
        }
        else {
            alert("something went wrong...");
            this.setState({loading: false});
        }
        

    }

    render() {
        let {icon_path, description, name, can_start} = this.props;
        let {loading} = this.state;

        
        let buttonExtraClass = "";
        if (!can_start) {
            buttonExtraClass = "inactive";
        }


        var playIconStyle = {
            marginRight: '5px', 
            display: 'inline-block'
        };

        let buttonClass = "quick_play_skill_card_play_button play_active_session_button " + buttonExtraClass;

        return (
            <div className='quick_play_skill_card'>
                <div className='quick_play_skill_card_title'>{name}</div>
                <div className='quick_play_skill_card_content'>                                   
                    <div className='quick_play_skill_card_image'>
                        <img alt="functional_skill_icon" src={this.props.getImage(icon_path)}></img>
                    </div>
                    <div className='quick_play_skill_card_label'> {description}</div> 
                </div>
                
                
                { !loading && 
                    <button onClick={this.startNewSession.bind(this)} className={buttonClass}><i className='fa fa-play' style={playIconStyle}></i> Start</button>
                }

                {
                    loading &&
                    <div className='functional_skill_card_loader'>Loading <i className='fa fa-spinner fa-spin'></i></div>
                }
                
                
            </div>
        );
    }
}

export default withStaticImages('quick-play-icons',QuickPlaySkillCard);


// WEBPACK FOOTER //
// ./src/components/containers/quick-play/quick-play-skill-card.js